var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('div',{staticClass:"border"},[_c('div',{staticClass:"inner-border"},[_vm._v("Items")]),_c('base-grid',{attrs:{"items":_vm.learningItems,"imageUrls":_vm.imageUrls,"gridId":"js-learning-items-grid"},on:{"grid:badge:click":function($event){return _vm.$router.push({
          name: 'learningItemMember',
          params: { id: $event.id }
        })}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }